export default "__VITE_ASSET__085d393d__"